export { CLIENT_ACTION_FETCH_RESOURCE_FAILURE } from 'src/app/popsicle/client/actions';

export const CLIENT_REGISTER = 'CLIENT_REGISTER';
export const CLIENT_START = 'CLIENT_START';

export const AUTH_SET_REDIRECT = 'AUTH_SET_REDIRECT';
export const AUTH_CLEAR_REDIRECT = 'AUTH_CLEAR_REDIRECT';

export const SEGMENT_PAGE = 'SEGMENT_PAGE';
export const SEGMENT_CLICK = 'SEGMENT_CLICK';
export const SEGMENT_TRACK = 'SEGMENT_TRACK';
export const SEGMENT_IDENTIFY = 'SEGMENT_IDENTIFY';
export const SEGMENT_CLEAR_IDENTIFY = 'SEGMENT_CLEAR_IDENTIFY';

export const SET_ROUTER_LOCATION = 'SET_ROUTER_LOCATION';

export const SESSION_SET_CURRENT_USER_ID = 'SESSION_SET_CURRENT_USER_ID';
export const SESSION_CLEAR_CURRENT_USER_ID = 'SESSION_CLEAR_CURRENT_USER_ID';

export const VIEW_SET_ORDERS = 'VIEW_SET_ORDERS';
export const VIEW_CLEAR_ORDERS = 'VIEW_CLEAR_ORDERS';

export const SET_ORDER_STATUS = 'SET_ORDER_STATUS';
export const SET_ORDER_STATUS_LOCATION = 'SET_ORDER_STATUS_LOCATION';

export const CART_ADD_ITEMS = 'CART_ADD_ITEMS';
export const CART_UPDATE_ITEMS = 'CART_UPDATE_ITEMS';
export const CART_REMOVE_ITEMS = 'CART_REMOVE_ITEMS';
export const CART_CLEAR = 'CART_CLEAR';
export const CHECKOUT_SET_ORDER = 'CHECKOUT_SET_ORDER';
export const CHECKOUT_REQUIRES_ACCOUNT = 'CHECKOUT_REQUIRES_ACCOUNT';

export const CHECKOUT_SET_DELIVERY_ADDRESS = 'CHECKOUT_SET_DELIVERY_ADDRESS';
export const CHECKOUT_SET_PAYMENT_CARD_ID = 'CHECKOUT_SET_PAYMENT_CARD_ID';
export const CHECKOUT_SET_DELIVERY_WINDOW = 'CHECKOUT_SET_DELIVERY_WINDOW';
export const CHECKOUT_SET_CART_ID = 'CHECKOUT_SET_CART_ID';

export const CLEAR_RESOURCE = 'CLEAR_RESOURCE';

export const LANDING_MODAL = 'LANDING_MODAL';
export const MODAL = 'MODAL';
export const FAMILY_MODAL = 'FAMILY_MODAL';
export const FAQ_MODAL = 'FAQ_MODAL';
export const OTC_MODAL = 'OTC_MODAL';
export const NEW_ARCHIVED_PAGE_MODAL = 'NEW_ARCHIVED_PAGE_MODAL';
export const PAGE_ALERT = 'PAGE_ALERT';
export const SNACK_BAR = 'SNACK_BAR';

export const SET_EDIT_ADDRESS_STATE = 'SET_EDIT_ADDRESS_STATE';
export const CLEAR_EDIT_ADDRESS_STATE = 'CLEAR_EDIT_ADDRESS_STATE';

export const SET_LOCATION = 'SET_LOCATION';
export const LOCATION_SHOW_DEBUG = 'LOCATION_SHOW_DEBUG';
export const CLEAR_LOCATION = 'CLEAR_LOCATION';

export const SET_VALIDATE_ADDRESS_SUGGESTIONS = 'SET_VALIDATE_ADDRESS_SUGGESTIONS';
export const SET_VALIDATE_ADDRESS_FLAG = 'SET_VALIDATE_ADDRESS_FLAG';
export const CLEAR_ADDRESS_VALIDATION = 'CLEAR_ADDRESS_VALIDATION';

export const REQUEST_MEDICATIONS_BY_NAME = 'REQUEST_MEDICATION_BY_NAME';
export const GET_CACHED_MEDICATION_BY_NAME = 'GET_CACHED_MEDICATION_BY_NAME';
export const RECEIVE_MEDICATIONS_BY_NAME = 'RECEIVE_MEDICATION_BY_NAME';

export const CREATE_DOCTOR_FORM = 'CREATE_DOCTOR_FORM';
export const UPDATE_DOCTOR_FORM = 'UPDATE_DOCTOR_FORM';
export const DELETE_DOCTOR_FORM = 'DELETE_DOCTOR_FORM';
export const DELETE_ALL_DOCTOR_FORMS = 'DELETE_ALL_DOCTOR_FORMS';
export const FETCH_ALL_DOCTOR_FORMS = 'FETCH_ALL_DOCTOR_FORMS';

export const CREATE_MEDICATION_FORM = 'CREATE_MEDICATION_FORM';
export const UPDATE_MEDICATION_SHOW_CONTROLLED_FORM = 'UPDATE_MEDICATION_SHOW_CONTROLLED_FORM';
export const DELETE_MEDICATION_FORM = 'DELETE_MEDICATION_FORM';
export const DELETE_ALL_MEDICATION_FORM = 'DELETE_ALL_MEDICATION_FORM';
export const FETCH_ALL_MEDICATION_FORMS = 'FETCH_ALL_MEDICATION_FORMS';
export const FETCH_MEDICATION_FORM_BY_INDEX = 'FETCH_MEDICATION_FORM_BY_INDEX';

export const FETCHING_INSURANCE = 'FETCHING_INSURANCE';
export const FETCHED_INSURANCE_SUCCESS = 'FETCHED_INSURANCE_SUCCESS';
export const FETCHED_PENDING_INSURANCE_SUCCESS = 'FETCHED_PENDING_INSURANCE_SUCCESS';
export const UPLOAD_INSURANCE_REQUEST = 'UPLOAD_INSURANCE_REQUEST';
export const UPLOAD_INSURANCE_SUCCESS = 'UPLOAD_INSURANCE_SUCCESS';
export const UPLOAD_INSURANCE_FAILURE = 'UPLOAD_INSURANCE_FAILURE';
export const HAS_FETCHED_INSURANCE = 'HAS_FETCHED_INSURANCE';

export const TOGGLE_HOME_SCREEN_ARCHIVE_SECTION = 'TOGGLE_HOME_SCREEN_ARCHIVE_SECTION';
export const SET_MOST_RECENTLY_UPDATED_MED = 'SET_MOST_RECENTLY_UPDATED_MED';

export const CLOSE_NEXT_BEST_ACTION_CARD = 'CLOSE_CARD';
export const RESET_CLOSED_NEXT_BEST_ACTION_CARDS = 'RESET_CLOSED_NEXT_BEST_ACTION_CARDS';

export const SET_REQUEST_REFILL_MODAL_STATUS = 'SET_REQUEST_REFILL_MODAL_STATUS';

export const SET_DEPENDENT = 'SET_DEPENDENT';

export const SET_FACILITY_IS_FETCHING = 'SET_FACILITY_IS_FETCHING';
export const SET_FACILITY_SUCCESS = 'SET_FACILITY_SUCCESS';
export const SET_FACILITY_ERROR = 'SET_FACILITY_ERROR';

export const SET_ACCOUNT_IS_FETCHING = 'SET_ACCOUNT_IS_FETCHING';
export const SET_ACCOUNT_SUCCESS = 'SET_ACCOUNT_SUCCESS';
export const SET_ACCOUNT_ERROR = 'SET_ACCOUNT_ERROR';

export const SET_ACCOUNT_UPDATE_REQUEST = 'SET_ACCOUNT_UPDATE_REQUEST';
export const SET_ACCOUNT_UPDATE_SUCCESS = 'SET_ACCOUNT_UPDATE_SUCCESS';
export const SET_ACCOUNT_UPDATE_ERROR = 'SET_ACCOUNT_UPDATE_ERROR';
export const SET_PHARMAKON_ACCOUNT_UPDATED = 'SET_ACCOUNT_UPDATED';

export const SET_PATIENT_IS_FETCHING = 'SET_PATIENT_IS_FETCHING';
export const SET_PATIENT_SUCCESS = 'SET_PATIENT_SUCCESS';
export const SET_PATIENT_ERROR = 'SET_PATIENT_ERROR';

export const SET_PAYMENT_CARDS_IS_FETCHING = 'SET_PAYMENT_CARDS_IS_FETCHING';
export const SET_PAYMENT_CARDS_SUCCESS = 'SET_PAYMENT_CARDS_SUCCESS';
export const SET_PAYMENT_CARDS_ERROR = 'SET_PAYMENT_CARDS_ERROR';
export const SET_PAYMENT_CARDS_UPDATE_SUCCESS = 'SET_PAYMENT_CARDS_UPDATE_SUCCESS';
export const SET_PAYMENT_CARDS_UPDATE_ERROR = 'SET_PAYMENT_CARDS_UPDATE_ERROR';
export const SET_PAYMENT_CARDS_DELETE_SUCCESS = 'SET_PAYMENT_CARDS_DELETE_SUCCESS';
export const SET_PAYMENT_CARDS_DELETE_ERROR = 'SET_PAYMENT_CARDS_DELETE_ERROR';

export const SET_DELIVERYADDRESS_IS_FETCHING = 'SET_DELIVERYADDRESS_IS_FETCHING';
export const SET_DELIVERYADDRESS_SUCCESS = 'SET_DELIVERYADDRESS_SUCCESS';
export const SET_DELIVERYADDRESS_ERROR = 'SET_DELIVERYADDRESS_ERROR';

export const REQUEST_CHECKOUT_DELIVERY_WINDOWS = 'REQUEST_CHECKOUT_DELIVERY_WINDOWS';
export const FETCH_CHECKOUT_DELIVERY_WINDOWS_SUCCESS = 'FETCH_CHECKOUT_DELIVERY_WINDOWS_SUCCESS';
export const FETCH_CHECKOUT_DELIVERY_WINDOWS_ERROR = 'FETCH_CHECKOUT_DELIVERY_WINDOWS_ERROR';

export const FETCH_MEDS_REQUEST = 'FETCH_MEDS_REQUEST';
export const FETCH_MEDS_SUCCESS = 'FETCH_MEDS_SUCCESS';
export const FETCH_MEDS_FAILURE = 'FETCH_MEDS_FAILURE';
export const FETCH_PENDING_TRANSFERS_SUCCESS = 'FETCH_PENDING_TRANSFERS_SUCCESS';
export const SET_OPTIMISTIC_PENDING_TRANSFER = 'SET_OPTIMISTIC_PENDING_TRANSFER';
export const SET_MEDICATION_SUCCESS = 'SET_MEDICATION_SUCCESS';

export const TOGGLE_NAV_HEADER = 'TOGGLE_NAV_HEADER';
export const RESET_NAV_BAR = 'RESET_NAV_BAR';
export const SET_HIDE_NAV_LINKS = 'SET_HIDE_NAV_LINKS';
export const SET_SHOW_CHECKOUT_TRANSFER_MODAL = 'SET_SHOW_CHECKOUT_TRANSFER_MODAL';

export const ADD_ONBOARDING_STEP = 'ADD_ONBOARDING_STEP';
export const EDIT_ONBOARDING_STEP = 'EDIT_ONBOARDING_STEP';
export const SET_CURRENT_ONBOARDING_STEP = 'SET_CURRENT_ONBOARDING_STEP';
export const REMOVE_ONBOARDING_STEP = 'REMOVE_ONBOARDING_STEP';

export const SET_ONBOARDING_VALUES = 'SET_ONBOARDING_VALUES';
export const SET_ONBOARDING_MEDICATIONS = 'SET_ONBOARDING_MEDICATIONS';
export const SET_SHOULD_TRANSFER_ALL_MEDS = 'SET_SHOULD_TRANSFER_ALL_MEDS';
export const SET_ONBOARDING_ESCRIPTS = 'SET_ONBOARDING_ESCRIPTS';
export const HYDRATE_ONBOARDING_STORAGE = 'HYDRATE_ONBOARDING_STORAGE';
export const SET_ONBOARDING_FLOW = 'SET_ONBOARDING_FLOW';
export const SET_ONBOARDING_ERROR = 'SET_ONBOARDING_ERROR';

export const SET_HORIZONTAL_PROGRESS_BAR_VISIBILITY = 'SET_HORIZONTAL_PROGRESS_BAR_VISIBILITY';

// Karyon Insurance Service
export const FETCH_LEGACY_INSURANCE_REQUEST = 'FETCH_LEGACY_INSURANCE_REQUEST';
export const FETCH_LEGACY_INSURANCE_SUCCESS = 'FETCH_LEGACY_INSURANCE_SUCCESS';
export const FETCH_LEGACY_INSURANCE_FAILURE = 'FETCH_LEGACY_INSURANCE_FAILURE';

export const VOID_PRIMARY_INSURANCE_REQUEST = 'VOID_PRIMARY_INSURANCE_REQUEST';
export const VOID_PRIMARY_INSURANCE_SUCCESS = 'VOID_PRIMARY_INSURANCE_SUCCESS';
export const VOID_PRIMARY_INSURANCE_FAILURE = 'VOID_PRIMARY_INSURANCE_FAILURE';

export const VOID_SECONDARY_INSURANCE_REQUEST = 'VOID_SECONDARY_INSURANCE_REQUEST';
export const VOID_SECONDARY_INSURANCE_SUCCESS = 'VOID_SECONDARY_INSURANCE_SUCCESS';
export const VOID_SECONDARY_INSURANCE_FAILURE = 'VOID_SECONDARY_INSURANCE_FAILURE';

export const FETCH_OTC_ITEMS_REQUEST = 'FETCH_OTC_ITEMS_REQUEST';
export const FETCH_OTC_ITEMS_SUCCESS = 'FETCH_OTC_ITEMS_SUCCESS';
export const FETCH_OTC_ITEMS_FAILURE = 'FETCH_OTC_ITEMS_FAILURE';

export const FETCH_CART_REQUEST = 'FETCH_CART_REQUEST';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_FAILURE = 'FETCH_CART_FAILURE';
export const UPDATE_BFF_CART = 'UPDATE_BFF_CART';

export const FETCH_CART_DELIVERY_METHODS_REQUEST = 'FETCH_CART_DELIVERY_METHODS_REQUEST';
export const FETCH_CART_DELIVERY_METHODS_SUCCESS = 'FETCH_CART_DELIVERY_METHODS_SUCCESS';
export const FETCH_CART_DELIVERY_METHODS_FAILURE = 'FETCH_CART_DELIVERY_METHODS_FAILURE';

export const FETCH_CART_DELIVERY_SHIPPING_OPTIONS_REQUEST = 'FETCH_CART_DELIVERY_SHIPPING_OPTIONS_REQUEST';
export const FETCH_CART_DELIVERY_SHIPPING_OPTIONS_SUCCESS = 'FETCH_CART_DELIVERY_SHIPPING_OPTIONS_SUCCESS';
export const FETCH_CART_DELIVERY_SHIPPING_OPTIONS_FAILURE = 'FETCH_CART_DELIVERY_SHIPPING_OPTIONS_FAILURE';

// TODO: Deprecated, remove after bff order history are in production (the actions below this)
export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';

export const CHECKOUT_CART_SUCCESS = 'CHECKOUT_CART_SUCCESS';
export const CHECKOUT_CART_ERROR = 'CHECKOUT_CART_ERROR';

export const SET_NUMBER_OF_ORDERS = 'SET_NUMBER_OF_ORDERS';
export const SET_HAS_TRANSFERS_FROM_GET_ENABLED_FEATURES_MAP_CALL =
  'SET_HAS_TRANSFERS_FROM_GET_ENABLED_FEATURES_MAP_CALL';
export const FETCH_ORDER_HISTORY = 'FETCH_ORDER_HISTORY';
export const FETCH_ORDER_HISTORY_SUCCESS = 'FETCH_ORDER_HISTORY_SUCCESS';
export const FETCH_ORDER_HISTORY_FAILURE = 'FETCH_ORDER_HISTORY_FAILURE';

export const SET_MEDICATION_LOADING_STATE = 'SET_MEDICATION_LOADING_STATE';

export const SET_OTC_CARD = 'SET_OTC_CARD';
export const CLEAR_OTC_CARD = 'CLEAR_OTC_CARD';

export const SET_IS_FETCHING_NEARBY = 'SET_IS_FETCHING_NEARBY';
export const SET_NEARBY_PLACES = 'SET_NEARBY_PLACES';
export const SET_SELECTED_PHARMACY = 'SET_SELECTED_PHARMACY';
export const RESET_PHARMACY_SEARCH = 'RESET_PHARMACY_SEARCH';

export const SET_ZIP_CODE_PROMO_SIGN_UP = 'SET_ZIP_CODE_PROMO_SIGN_UP';
export const SET_CURRENT_PROMO_ONBOARDING_STEP = 'SET_CURRENT_PROMO_ONBOARDING_STEP';
export const SET_NAVIGATE_TO_NEXT_PROMO_ONBOARDING_STEP = 'SET_NAVIGATE_TO_NEXT_PROMO_ONBOARDING_STEP';
export const SET_PROMO_TRANSFER_MEDICATIONS = 'SET_PROMO_TRANSFER_MEDICATIONS';
export const SET_PROMO_ONBOARDING_HAS_EXISTING_ACCOUNT = 'SET_PROMO_ONBOARDING_HAS_EXISTING_ACCOUNT';
export const SET_PROMO_ONBOARDING_WORK_EMAIL = 'SET_PROMO_ONBOARDING_WORK_EMAIL';
export const SET_PROMO_CODE_FOR_ONBOARDING = 'SET_PROMO_CODE_FOR_ONBOARDING';

export const SET_TRANSFER_FORM_STEP = 'SET_TRANSFER_FORM_STEP';
export const ADD_TRANSFER_FORM_STEP = 'ADD_TRANSFER_FORM_STEP';
export const REMOVE_TRANSFER_FORM_STEP = 'REMOVE_TRANSFER_FORM_STEP';
export const SET_PATIENT_TRANSFER_FORM = 'SET_PATIENT_TRANSFER_FORM';

export const FETCH_VERIFY_EMAIL_SUCCESS = 'FETCH_VERIFY_EMAIL_SUCCESS';
export const FETCH_VERIFY_EMAIL_FAILURE = 'FETCH_VERIFY_EMAIL_FAILURE';
export const FETCH_VERIFY_EMAIL_REQUEST = 'FETCH_VERIFY_EMAIL_REQUEST';
export const CLEAR_VERIFY_EMAIL = 'CLEAR_VERIFY_EMAIL';

export const SET_CURRENT_ROUTER_LOCATION = 'SET_CURRENT_ROUTER_LOCATION';

export const COMPLETE_CHECKOUT_TRANSFER = 'COMPLETE_CHECKOUT_TRANSFER';
export const COMPLETE_CHECKOUT_CONTACT_INFO = 'COMPLETE_CHECKOUT_CONTACT_INFO';
export const SET_SELECTED_DELIVERY_METHOD_LABEL_FROM_CHECKOUT = 'SET_SELECTED_DELIVERY_METHOD_LABEL_FROM_CHECKOUT';
export const SET_NEW_ARCHIVED_PAGE_MODAL_SHOWN = 'SET_NEW_ARCHIVED_PAGE_MODAL_SHOWN';
export const RESET_NEW_ARCHIVED_PAGE_MODAL_SHOWN = 'RESET_NEW_ARCHIVED_PAGE_MODAL_SHOWN';

export const FETCH_PROMO_CODE_DETAILS = 'FETCH_PROMO_CODE_DETAILS';
export const FETCH_PROMO_CODE_DETAILS_SUCCESS = 'FETCH_PROMO_CODE_DETAILS_SUCCESS';
export const FETCH_PROMO_CODE_DETAILS_ERROR = 'FETCH_PROMO_CODE_DETAILS_ERROR';

export const GET_MEDICATION_DETAILS_REQUEST = 'GET_MEDICATION_DETAILS_REQUEST';
export const GET_MEDICATION_DETAILS_SUCCESS = 'GET_MEDICATION_DETAILS_SUCCESS';
export const GET_MEDICATION_DETAILS_FAILURE = 'GET_MEDICATION_DETAILS_FAILURE';
export const SET_CURRENT_PRESCRIPTION_ID = 'SET_CURRENT_PRESCRIPTION_ID';
export const CLEAR_MEDICATION_DETAILS_ERROR = 'CLEAR_MEDICATION_DETAILS_ERROR';

export const ADD_MED_INPUT_FIELD_ON_FOCUS = 'ADD_MED_INPUT_FIELD_ON_FOCUS';
export const INPUT_FIELD_FOCUSED = 'INPUT_FIELD_FOCUSED';
export const INPUT_FIELD_BLUR = 'INPUT_FIELD_BLUR';

export const FETCH_CHECKOUT_PICKUP_STATIONS = 'FETCH_CHECKOUT_PICKUP_STATIONS';
export const FETCH_CHECKOUT_PICKUP_STATIONS_SUCCESS = 'FETCH_CHECKOUT_PICKUP_STATIONS_SUCCESS';
export const FETCH_CHECKOUT_PICKUP_STATIONS_ERROR = 'FETCH_CHECKOUT_PICKUP_STATIONS_ERROR';
export const CLEAR_CHECKOUT_PICKUP_STATIONS = 'CLEAR_CHECKOUT_PICKUP_STATIONS';

export const GET_MEDICATION_GUIDES_REQUEST = 'GET_MEDICATION_GUIDES_REQUEST';
export const GET_MEDICATION_GUIDES_SUCCESS = 'GET_MEDICATION_GUIDES_SUCCESS';
export const GET_MEDICATION_GUIDES_FAILURE = 'GET_MEDICATION_GUIDES_FAILURE';

export const SET_CUSTOM_ERROR_MODAL = 'SET_CUSTOM_ERROR_MODAL';
export const CLEAR_NETWORK_ERRORS = 'CLEAR_NETWORK_ERRORS';
